export function getBrowserMedia(state) {
  return state.browser.media;
}



// WEBPACK FOOTER //
// ./src/core/browser/selectors.js